interface LineTrackerProps {
  colorStatus?: string;
  position: number;
  steps: string[];
}

export const LineTracker: React.FC<LineTrackerProps> = ({
  colorStatus,
  position,
  steps,
}) => {
  return (
    <>
      {position < steps.length - 1 && (
        <div
          data-testid="line-tracker"
          style={{
            width: '2px',
            backgroundColor: colorStatus,
            marginLeft: '0.4rem',
            marginTop: '4px',
            height: '2rem',
          }}
        />
      )}
    </>
  );
};
